module.exports = __webpack_public_path__ + "static/media/vf_mpants_core.775df20d.svg";